import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=0f87c943&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=0f87c943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87c943",
  null
  
)

export default component.exports